module.exports = __webpack_public_path__ + "img/ic_20_report_progress-active.f88f817c.svg";